import './src/css/global.css'
import './src/css/vendors.css'
import './src/css/icon.css'
import './src/css/style.css'
import './src/css/responsive.css'
import './src/css/mermaid.css'

// Fire GA4 lead events on any LINE/phone CTA, site-wide, via one delegated listener —
// covers every current and future booking link without touching each component.
// Mark contact_line / contact_phone as Key events in GA4 to track conversions.
export const onClientEntry = () => {
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href]')
    if (!a || typeof window.gtag !== 'function') return
    const href = a.getAttribute('href') || ''
    let event
    if (/line\.me|lin\.ee/i.test(href)) event = 'contact_line'
    else if (href.startsWith('tel:')) event = 'contact_phone'
    else return
    // beacon so the hit still sends while the browser navigates to tel:/LINE
    window.gtag('event', event, { transport_type: 'beacon' })
  }, true)
}
